// extracted by mini-css-extract-plugin
export default {"pageNot":"PageNot_pageNot__ssQA7"};